module.exports = __webpack_public_path__ + "img/CrystalMaiden.fa9def33.png";